import { alpha } from "@mui/material/styles";
import type { ThemeAndColors } from "../types";
import { brandingDebug } from "./brandingDebug";

export function applyCSSVariables(themeAndColors: ThemeAndColors): void {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  root.style.setProperty("--brand-primary", themeAndColors.primaryColor);
  root.style.setProperty("--brand-secondary", themeAndColors.secondaryColor);
  root.style.setProperty(
    "--brand-primary-font",
    themeAndColors.primaryFontColor,
  );
  root.style.setProperty(
    "--brand-secondary-font",
    themeAndColors.secondaryFontColor,
  );
  root.style.setProperty(
    "--brand-header-background",
    themeAndColors.headerBackgroundColor ?? themeAndColors.primaryColor,
  );
  root.style.setProperty(
    "--brand-primary-selected-background",
    alpha(themeAndColors.primaryColor, 0.08),
  );

  brandingDebug("applyCSSVariables", {
    primaryColor: themeAndColors.primaryColor,
    headerBackgroundColor: themeAndColors.headerBackgroundColor,
    cssVarPrimary: root.style.getPropertyValue("--brand-primary"),
    cssVarHeader: root.style.getPropertyValue("--brand-header-background"),
  });
}
